angular
	.module 'App.Repository'
	.factory 'AddonProductMetadataRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class AddonProductMetadataRepository extends BaseRepository
				@resource = '/addon_product_metadata'
				@isRestricted = true

			return new AddonProductMetadataRepository
	]
